import {useSelector} from 'react-redux'

import {AppState} from '../../App.reducer'

export const useLoggedInUser = () => {
  return useSelector((state: AppState) =>
    state.loggedInUser === undefined ? null : state.loggedInUser.profile
  )
}
